"use client";

import { useSegment as useSegmentBase } from "@bigspring/core-components/helpers";
import { getRuntimeConfigOptional } from "@lib/runtimeEnvClient";

export function useSegment() {
  const segmentEnabled = getRuntimeConfigOptional(
    "NEXT_PUBLIC_SEGMENT_ENABLED"
  );

  return useSegmentBase(segmentEnabled === "1");
}
